import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { environment } from '../../environments/environment';
import type { ImpressumDto } from '../models/restaurant-api.model';

@Injectable({ providedIn: 'root' })
export class ImpressumService {
  private readonly http = inject(HttpClient);

  getImpressum(): Observable<ImpressumDto | null> {
    return this.http
      .get<ImpressumDto>(`${environment.apiUrl}/api/impressum`)
      .pipe(catchError(() => of(null)));
  }
}
